"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastingFormListDataFieldsFromJSON = CastingFormListDataFieldsFromJSON;
exports.CastingFormListDataFieldsFromJSONTyped = CastingFormListDataFieldsFromJSONTyped;
exports.CastingFormListDataFieldsToJSON = CastingFormListDataFieldsToJSON;
exports.CastingFormListDataFieldsToJSONTyped = CastingFormListDataFieldsToJSONTyped;
const _1 = require("./");
function CastingFormListDataFieldsFromJSON(json) {
    return CastingFormListDataFieldsFromJSONTyped(json, false);
}
function CastingFormListDataFieldsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...(0, _1.CastingFormListDataFieldsGroupFromJSONTyped)(json, true), ...(0, _1.CastingFormListDataFieldsSingleFromJSONTyped)(json, true) };
}
function CastingFormListDataFieldsToJSON(value) {
    return CastingFormListDataFieldsToJSONTyped(value, false);
}
function CastingFormListDataFieldsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return { ...(0, _1.CastingFormListDataFieldsGroupToJSON)(value), ...(0, _1.CastingFormListDataFieldsSingleToJSON)(value) };
}
